import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import EngravingInput from '../engraving-input'
import {Box, Text, Image} from '@salesforce/retail-react-app/app/components/shared/ui'
import {getUrl} from '../../../../utils/cloudinary-utils'

const LineThree = (props) => {
    const {
        setVisibleLine,
        visibleLine,
        showInitialSpinner,
        shouldShow3LineToggle,
        engravingLines,
        selectedFace,
        maxLength,
        product,
        setShowFonts,
        selectedHeading,
        setSelectedHeading,
        displayIconType,
        setDisplayIconType,
        restrictionListArray,
        handleLineChange,
        selectedFont
    } = props
    return (
        <Box className="line-3-box">
            {shouldShow3LineToggle && selectedFont[selectedFace] !== 'Monogram' && (
                <Box
                    mt="30px"
                    textAlign="right"
                    onClick={() => {
                        setVisibleLine(visibleLine === 'line3' ? '' : 'line3')
                    }}
                    display={!showInitialSpinner ? 'flex' : 'none'}
                    alignItems="center"
                    cursor="pointer"
                    justifyContent="space-between"
                >
                    <Box gap="15px" display="inline-flex">
                        <Text
                            color="teal.500"
                            fontSize="16px"
                            fontWeight="400"
                            letterSpacing="0.08px"
                            lineHeight="25px"
                        >
                            <FormattedMessage id="line3" defaultMessage="Line 3" />
                        </Text>
                        {engravingLines?.[selectedFace]?.line3 ? (
                            <Text
                                color="black.100"
                                fontSize="16px"
                                fontFamily="ksSansSerif"
                                fontWeight="300"
                                marginTop="2px"
                                letterSpacing="0.08px"
                                lineHeight="25px"
                            >
                                {engravingLines?.[selectedFace]?.line3
                                    ?.replaceAll('{{#font=kendra-characters-24-01-22.ttf}}', '')
                                    ?.replaceAll('{{/}}', '')}
                            </Text>
                        ) : (
                            <Text
                                color="black.100"
                                fontSize="16px"
                                display={visibleLine !== 'line3' ? 'block' : 'none'}
                                fontFamily="ksSansSerif"
                                fontWeight="300"
                                letterSpacing="0.08px"
                                lineHeight="25px"
                            >
                                <FormattedMessage
                                    id="engraving.line3.optional"
                                    defaultMessage="(Optional)"
                                />
                            </Text>
                        )}
                    </Box>
                    <Box display="flex" alignItems="center" gap="10px">
                        <Text
                            display={visibleLine === 'line3' ? 'none' : 'block'}
                            fontSize="13px"
                            fontWeight="300"
                            textDecoration="underline"
                            textUnderlineOffset="4px"
                            color="black.300"
                            lineHeight="22px"
                        >
                            {engravingLines?.[selectedFace]?.line3 ? (
                                <FormattedMessage id="edit.free.engraving" defaultMessage="Edit" />
                            ) : (
                                <FormattedMessage
                                    id="engraving.add.new.line"
                                    defaultMessage="Add a New Line"
                                />
                            )}
                        </Text>
                        <Image
                            width="15px"
                            height="15px"
                            alt="arrow"
                            transform={visibleLine === 'line3' ? 'rotate(-90deg)' : 'rotate(90deg)'}
                            src={getUrl('UIImages/images/redesign/arrow-default.svg')}
                        />
                    </Box>
                </Box>
            )}

            <Box
                className={`engraving-third-line-wrapper ${
                    visibleLine === 'line3' && selectedFont[selectedFace] !== 'Monogram'
                        ? 'show'
                        : ''
                }`}
                mt="0px"
                display={!showInitialSpinner ? 'block' : 'none'}
                data-selected-face={selectedFace}
            >
                <Box display={{base: 'none', md: 'block'}} marginTop="20px">
                    <Text color="gray.800" fontSize="13" fontWeight="400">
                        <FormattedMessage
                            id="engraving.type.initials"
                            defaultMessage="Type in initials or add a symbol. You can even combine them."
                        />
                    </Text>
                    <Text color="gray.800" fontSize="13" fontWeight="300" marginTop="5px">
                        {maxLength === 1 && (
                            <FormattedMessage
                                id="engraving.one.length.available"
                                defaultMessage="This piece has a max of 1 character(s)."
                            />
                        )}
                    </Text>
                </Box>
                <EngravingInput
                    id="engraving-third-line"
                    product={product}
                    setShowFonts={setShowFonts}
                    selectedHeading={selectedHeading}
                    setSelectedHeading={setSelectedHeading}
                    displayIconType={displayIconType}
                    setDisplayIconType={(val) => {
                        setDisplayIconType(val)
                    }}
                    restrictionListArray={restrictionListArray}
                    maxLength={maxLength}
                    showInitialSpinner={showInitialSpinner}
                    value={engravingLines[selectedFace]?.line3}
                    handleLineChange={(value) => {
                        handleLineChange(value, 'line3')
                    }}
                    selectedFaceLines={engravingLines[selectedFace]}
                    selectedFont={selectedFont[selectedFace]}
                />
            </Box>
        </Box>
    )
}

LineThree.propTypes = {
    setVisibleLine: PropTypes.func,
    visibleLine: PropTypes.number,
    showInitialSpinner: PropTypes.bool,
    shouldShow3LineToggle: PropTypes.bool,
    engravingLines: PropTypes.any,
    selectedFace: PropTypes.string,
    maxLength: PropTypes.number,
    product: PropTypes.object,
    setShowFonts: PropTypes.func,
    selectedHeading: PropTypes.string,
    setSelectedHeading: PropTypes.func,
    displayIconType: PropTypes.string,
    setDisplayIconType: PropTypes.func,
    restrictionListArray: PropTypes.array,
    handleLineChange: PropTypes.func,
    selectedFont: PropTypes.string
}

export default LineThree
